
import React from 'react';
import { 
  LayoutDashboard, 
  FileText, 
  Users,
  Settings,
  Building, 
  Package 
} from 'lucide-react';
import SidebarNavItem from './SidebarNavItem';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useLanguage } from '@/hooks/useLanguage';

interface SidebarNavigationProps {
  isSidebarOpen: boolean;
}

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({ isSidebarOpen }) => {
  const { translate } = useLanguage();
  
  const navigationItems = [
    { name: translate('navigation.dashboard'), path: '/', icon: LayoutDashboard },
    { name: translate('navigation.subscriptions'), path: '/subscriptions', icon: Users },
    { name: translate('navigation.customers'), path: '/customers', icon: Building },
    { name: translate('navigation.services'), path: '/services', icon: Package },
    { name: translate('navigation.invoices'), path: '/invoices', icon: FileText },
    { name: translate('navigation.settings'), path: '/settings', icon: Settings },
  ];

  return (
    <nav className="flex-1 py-4 overflow-y-auto">
      <TooltipProvider>
        <ul className="space-y-1 px-2">
          {navigationItems.map((item) => (
            <SidebarNavItem
              key={item.name}
              name={item.name}
              path={item.path}
              icon={item.icon}
              isSidebarOpen={isSidebarOpen}
            />
          ))}
        </ul>
      </TooltipProvider>
    </nav>
  );
};

export default SidebarNavigation;
